import { render, staticRenderFns } from "./ResidentSettings.vue?vue&type=template&id=477efe94&scoped=true"
import script from "./ResidentSettings.ts?vue&type=script&lang=ts&external"
export * from "./ResidentSettings.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477efe94",
  null
  
)

export default component.exports